import { BASE_API_URL } from "../../../../config/url"

export const FORGOTPASSWORD_DONE = 'FORGOTPASSWORD_DONE'

export const FORGOTPASSWORD_API_URL = `${BASE_API_URL}/onboarding/user/forgetpassword`